var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVenmo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18069 3.15932C8.18069 2.13858 8.00758 1.44349 7.73644 0.870844L11.9991 0C12.4919 0.821232 12.714 1.66674 12.714 2.73498C12.714 6.14235 9.83049 10.5683 7.4898 13.6765H2.14411L0 0.746287L4.68086 0.298198L5.81445 9.49906C6.87347 7.75895 8.18069 5.02398 8.18069 3.15932Z",
    fill: "#008CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenmo);
export default __webpack_public_path__ + "static/media/venmo.b22a50ce2a3a700e64687c094a4dd09f.svg";
export { ForwardRef as ReactComponent };